import './ModelRow.css';

/**
 * One RVT, wherever it's shown in the folder browser. Sourced straight from
 * a folder-contents entry (`{lineageUrn, name}`) — the folder browser is
 * the source of truth for what's in ACC, not the separate `/aps/rvt-models`
 * catalog, which exists only to feed the "links to a model not in this
 * group" tip shown in the editor.
 */
export const ModelRow = ({
    lineageUrn,
    name,
    selectedUrns,
    onToggleModel,
    otherGroupsByUrn,
    disabled,
}) => {
    const isSelected = selectedUrns.has(lineageUrn);
    const otherGroups = otherGroupsByUrn.get(lineageUrn) ?? [];

    return (
        <label className={`mg-model-row${isSelected ? ' mg-model-row-selected' : ''}`}>
            <input
                type="checkbox"
                checked={isSelected}
                disabled={disabled}
                onChange={() => onToggleModel(lineageUrn, name)}
            />
            <span className="mg-model-icon" aria-hidden="true" />
            <span className="mg-model-name">{name ?? lineageUrn}</span>
            {otherGroups.length > 0 && (
                <span className="mg-model-also-in">Also in: {otherGroups.join(', ')}</span>
            )}
        </label>
    );
};
